export type CopyKey = 'items' | 'modifiers'

/** Copy names a level by what it holds: canonical pickers hold items or modifiers */
const copyKeyOf = (levelId: string): CopyKey =>
  levelId === 'modifiers' ? 'modifiers' : 'items'

export default copyKeyOf
